import React from 'react'
import { _ } from 'utils'
import FormTabs from 'features/forms/FormTabs'
import { Formik } from 'formik'
import ShowList from './ShowList'
import ProgramTags from './tabs/ProgramTags'

const ShowListSetting = () => (
    <Formik initialValues={{ email: '' }} onSubmit={() => {}}>
        <>
            <FormTabs
                tabs={[
                    {
                        id: 'programe',
                        name: 'Programe',
                        Component: ShowList
                    },
                    {
                        id: 'tag',
                        name: _('show.tabs.tags_management'),
                        Component: ProgramTags
                    },
                ]}
            />
        </>
    </Formik>
)

export default ShowListSetting
